import dispatchEvent from "../app/util/dispatchEvent";
import {CART_UPDATED, OPEN_CART} from "../app/util/events";
const axios = require('axios');

const endPoint = 'cart-api/add-to-cart';

export default (productId, callback) => {
    const formData = new FormData();
    formData.set('product_id', productId);
    axios.post(endPoint, formData, {
        headers: {
            'x-requested-with': 'XMLHttpRequest'
        }
    }).then((response) => {
        dispatchEvent(CART_UPDATED, response.data);
        dispatchEvent(OPEN_CART);
        if (callback) {
            callback();
        }
    });

}
